import { jsx as _jsx } from "react/jsx-runtime";
import { useSnackbar, useTheme, Button, DataGrid, Icon, Typography } from '@emburse/embark-core';
import { useContext } from 'react';
import { CheckBoxIcon } from '@emburse/embark-icons';
import { $t, useTranslation } from '../../../hooks/useTranslation';
import { CorpMerchantCodesContext } from '../CorpMerchantCodesProvider';
function CorpMerchantCodesDataGrid() {
    useTranslation();
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const { merchantCodeBeingUpdated, merchantCodes, merchantCodePageload, saveMerchantCode } = useContext(CorpMerchantCodesContext);
    return (_jsx(DataGrid, { columns: [
            {
                field: 'merchantCodeLinkedStatus',
                headerName: '',
                flex: 1,
                renderCell: (params) => {
                    if (merchantCodePageload.MerchantCodesSelected.includes(params.row.MerchantCodeID)) {
                        return (_jsx(Icon, { sx: { color: theme.palette.success.main }, iconUrl: CheckBoxIcon }));
                    }
                    return null;
                }
            },
            {
                field: 'merchantCode',
                headerName: 'Code',
                flex: 2,
                renderCell: (params) => (_jsx(Typography, { noWrap: true, children: params.row.Code }))
            },
            {
                field: 'merchantCodeDescription',
                headerName: 'Description',
                flex: 20,
                renderCell: (params) => (_jsx(Typography, { noWrap: true, children: params.row.Name }))
            },
            {
                field: 'merchantCodeGroup',
                headerName: 'Group',
                flex: 8,
                renderCell: (params) => (_jsx(Typography, { noWrap: true, children: merchantCodePageload.MerchantCodeGroups.find((group) => group.PK === params.row.MerchantCodeGroupID)?.Name }))
            },
            {
                field: 'merchantCodeAction',
                headerName: '',
                flex: 3,
                renderCell: (params) => {
                    const linked = merchantCodePageload.MerchantCodesSelected.includes(params.row.MerchantCodeID);
                    const action = linked ? 'Unlink' : 'Link';
                    const dataQa = linked ? 'unlink-merchant-code' : 'link-merchant-code';
                    return (_jsx(Button, { variant: "text", onClick: async () => {
                            try {
                                await saveMerchantCode(params.row.MerchantCodeID, !linked);
                                enqueueSnackbar($t(`Merchant code ${action.toLocaleLowerCase()}ed successfully`), { variant: 'success' });
                            }
                            catch (err) {
                                enqueueSnackbar(err.message, { variant: 'error' });
                            }
                        }, "data-qa": dataQa, children: action }));
                }
            }
        ], rows: merchantCodes, pageSizeOptions: [25, 50, 100], initialState: {
            pagination: {
                paginationModel: {
                    pageSize: 50
                }
            }
        }, sx: {
            width: '100%',
            '& .row-being-updated': {
                backgroundColor: theme.palette.action.hover
            }
        }, autoHeight: true, sortModel: [], getRowClassName: (params) => {
            if (params.row.MerchantCodeID === merchantCodeBeingUpdated) {
                return 'row-being-updated';
            }
            return '';
        } }));
}
export default CorpMerchantCodesDataGrid;
